import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const api = {
  // Constants
  getConstants: async () => {
    const { data } = await axios.get(`${API}/constants`);
    return data;
  },

  // Sales
  createSale: async (sale) => {
    const { data } = await axios.post(`${API}/sales`, sale, { headers: getHeaders() });
    return data;
  },
  
  getSales: async (params = {}) => {
    const { data } = await axios.get(`${API}/sales`, { params, headers: getHeaders() });
    return data;
  },
  
  deleteSale: async (id) => {
    const { data } = await axios.delete(`${API}/sales/${id}`, { headers: getHeaders() });
    return data;
  },
  
  getSalesStats: async () => {
    const { data } = await axios.get(`${API}/sales/stats`, { headers: getHeaders() });
    return data;
  },
  
  getSalesBySupervisor: async () => {
    const { data } = await axios.get(`${API}/sales/by-supervisor`, { headers: getHeaders() });
    return data;
  },
  
  getSalesByMonth: async (year = 2026) => {
    const { data } = await axios.get(`${API}/sales/by-month`, { params: { year }, headers: getHeaders() });
    return data;
  },
  
  getVendorPerformance: async () => {
    const { data } = await axios.get(`${API}/sales/vendor-performance`, { headers: getHeaders() });
    return data;
  },

  // Diferencia Fonasa
  createDiferenciaFonasa: async (data) => {
    const { data: res } = await axios.post(`${API}/diferencia-fonasa`, data, { headers: getHeaders() });
    return res;
  },
  
  getDiferenciaFonasa: async (params = {}) => {
    const { data } = await axios.get(`${API}/diferencia-fonasa`, { params, headers: getHeaders() });
    return data;
  },
  
  getDiferenciaStats: async () => {
    const { data } = await axios.get(`${API}/diferencia-fonasa/stats`, { headers: getHeaders() });
    return data;
  },
  getDiferenciaMonthly: async (año) => {
    const params = {};
    if (año) params.año = año;
    const { data } = await axios.get(`${API}/diferencia-fonasa/monthly`, { params, headers: getHeaders() });
    return data;
  },
  
  deleteDiferenciaFonasa: async (fecha) => {
    const { data } = await axios.delete(`${API}/diferencia-fonasa/${fecha}`, { headers: getHeaders() });
    return data;
  },

  // Auth
  registerVendor: async (data) => {
    const { data: result } = await axios.post(`${API}/auth/register/vendor`, data);
    return result;
  },

  // Vendors
  createVendor: async (vendor) => {
    const { data } = await axios.post(`${API}/vendors`, vendor, { headers: getHeaders() });
    return data;
  },
  
  getVendors: async (search = '') => {
    const { data } = await axios.get(`${API}/vendors`, { params: { search }, headers: getHeaders() });
    return data;
  },
  
  getVendor: async (id) => {
    const { data } = await axios.get(`${API}/vendors/${id}`, { headers: getHeaders() });
    return data;
  },
  
  updateVendor: async (id, update) => {
    const { data } = await axios.put(`${API}/vendors/${id}`, update, { headers: getHeaders() });
    return data;
  },
  
  updateVendorStatus: async (id, status) => {
    const { data } = await axios.put(`${API}/vendors/${id}/status`, status, { headers: getHeaders() });
    return data;
  },
  
  getVendorsRanking: async (mes, año, periodo, fecha_desde, fecha_hasta) => {
    const params = {};
    if (mes) params.mes = mes;
    if (año) params.año = año;
    if (periodo) params.periodo = periodo;
    if (fecha_desde) params.fecha_desde = fecha_desde;
    if (fecha_hasta) params.fecha_hasta = fecha_hasta;
    const { data } = await axios.get(`${API}/vendors/ranking`, { params, headers: getHeaders() });
    return data;
  },
  
  getVendorStats: async (id) => {
    const { data } = await axios.get(`${API}/vendors/${id}/stats`, { headers: getHeaders() });
    return data;
  },

  // Licencias
  createLicencia: async (licencia) => {
    const { data } = await axios.post(`${API}/licencias`, licencia, { headers: getHeaders() });
    return data;
  },
  
  getLicencias: async (activeOnly = false) => {
    const { data } = await axios.get(`${API}/licencias`, { params: { active_only: activeOnly }, headers: getHeaders() });
    return data;
  },
  
  deleteLicencia: async (id) => {
    const { data } = await axios.delete(`${API}/licencias/${id}`, { headers: getHeaders() });
    return data;
  },

  // Groups
  createGroup: async (group) => {
    const { data } = await axios.post(`${API}/groups`, group, { headers: getHeaders() });
    return data;
  },
  
  getGroups: async () => {
    const { data } = await axios.get(`${API}/groups`, { headers: getHeaders() });
    return data;
  },
  
  deleteGroup: async (id) => {
    const { data } = await axios.delete(`${API}/groups/${id}`, { headers: getHeaders() });
    return data;
  },

  // Guardias
  createGuardia: async (guardia) => {
    const { data } = await axios.post(`${API}/guardias`, guardia, { headers: getHeaders() });
    return data;
  },
  
  getGuardias: async (upcoming = false) => {
    const { data } = await axios.get(`${API}/guardias`, { params: { upcoming }, headers: getHeaders() });
    return data;
  },
  
  deleteGuardia: async (id) => {
    const { data } = await axios.delete(`${API}/guardias/${id}`, { headers: getHeaders() });
    return data;
  },

  // Calculator
  calculateCommissions: async (quantities) => {
    const { data } = await axios.post(`${API}/calculator`, { quantities }, { headers: getHeaders() });
    return data;
  },

  getCommissionRates: async () => {
    const { data } = await axios.get(`${API}/commission-rates`, { headers: getHeaders() });
    return data;
  },

  updateCommissionRates: async (rates) => {
    const { data } = await axios.put(`${API}/commission-rates`, { rates }, { headers: getHeaders() });
    return data;
  },

  // Requests
  getPendingRequests: async () => {
    const { data } = await axios.get(`${API}/requests`, { headers: getHeaders() });
    return data;
  },
  
  approveRequest: async (id) => {
    const { data } = await axios.post(`${API}/requests/${id}/approve`, {}, { headers: getHeaders() });
    return data;
  },
  
  rejectRequest: async (id) => {
    const { data } = await axios.post(`${API}/requests/${id}/reject`, {}, { headers: getHeaders() });
    return data;
  },

  // Asistencia (Attendance)
  updateAsistencia: async (payload) => {
    const { data } = await axios.put(`${API}/asistencia`, payload, { headers: getHeaders() });
    return data;
  },

  getAsistencia: async (vendedorId, mes, año) => {
    const { data } = await axios.get(`${API}/asistencia/${vendedorId}`, { params: { mes, año }, headers: getHeaders() });
    return data;
  },

  getAllAsistencia: async (mes, año) => {
    const { data } = await axios.get(`${API}/asistencia`, { params: { mes, año }, headers: getHeaders() });
    return data;
  },

  deactivateVendor: async (id) => {
    const { data } = await axios.put(`${API}/vendors/${id}/deactivate`, {}, { headers: getHeaders() });
    return data;
  },
  
  deleteVendor: async (id) => {
    const { data } = await axios.delete(`${API}/vendors/${id}`, { headers: getHeaders() });
    return data;
  },
  
  activateVendor: async (id) => {
    const { data } = await axios.put(`${API}/vendors/${id}/activate`, {}, { headers: getHeaders() });
    return data;
  },

  // Vendor Goals
  getVendorGoals: async (vendorId) => {
    const { data } = await axios.get(`${API}/vendor-goals/${vendorId}`, { headers: getHeaders() });
    return data;
  },

  setVendorGoals: async (vendorId, goals) => {
    const { data } = await axios.put(`${API}/vendor-goals/${vendorId}`, { goals }, { headers: getHeaders() });
    return data;
  },

  getAllVendorGoals: async () => {
    const { data } = await axios.get(`${API}/vendor-goals`, { headers: getHeaders() });
    return data;
  },

  // Fonasa No Vendido (Auditor only)
  addFonasaNoVendido: async (payload) => {
    const { data } = await axios.post(`${API}/fonasa-no-vendido`, payload, { headers: getHeaders() });
    return data;
  },

  getFonasaNoVendido: async (mes, año) => {
    const params = {};
    if (mes) params.mes = mes;
    if (año) params.año = año;
    const { data } = await axios.get(`${API}/fonasa-no-vendido`, { params, headers: getHeaders() });
    return data;
  },

  deleteFonasaNoVendido: async (id) => {
    const { data } = await axios.delete(`${API}/fonasa-no-vendido/${id}`, { headers: getHeaders() });
    return data;
  },

  // Mi Historial (vendor self-view)
  getMiHistorial: async () => {
    const { data } = await axios.get(`${API}/mi-historial`, { headers: getHeaders() });
    return data;
  },

  // Weekly Export
  getWeeklyExport: async () => {
    const { data } = await axios.get(`${API}/sales/weekly-export`, { headers: getHeaders() });
    return data;
  },

  // Forgot Password
  forgotPassword: async (username) => {
    const { data } = await axios.post(`${API}/auth/forgot-password`, { username });
    return data;
  },

  // Historical Sales
  updateVentasHistoricas: async (payload) => {
    const { data } = await axios.put(`${API}/sales/historical`, payload, { headers: getHeaders() });
    return data;
  },
  getFonasaSales: async (mes, año) => {
    const { data } = await axios.get(`${API}/sales/fonasa`, { params: { mes, año }, headers: getHeaders() });
    return data;
  },
  getVentasHistoricas: async (vendedorId, mes, año) => {
    const { data } = await axios.get(`${API}/sales/historical/${vendedorId}`, { params: { mes, año }, headers: getHeaders() });
    return data;
  },
  getAllVentasHistoricas: async (mes, año) => {
    const { data } = await axios.get(`${API}/sales/historical`, { params: { mes, año }, headers: getHeaders() });
    return data;
  },
  getEvolucionVendedores: async (año) => {
    const { data } = await axios.get(`${API}/sales/historical/evolution`, { params: { año }, headers: getHeaders() });
    return data;
  },
  createFonasaRegistro: async (payload) => {
    const { data } = await axios.post(`${API}/fonasa-registros`, payload, { headers: getHeaders() });
    return data;
  },
  getFonasaRegistros: async (mes, año) => {
    const { data } = await axios.get(`${API}/fonasa-registros`, { params: { mes, año }, headers: getHeaders() });
    return data;
  },
  deleteFonasaRegistro: async (id) => {
    const { data } = await axios.delete(`${API}/fonasa-registros/${id}`, { headers: getHeaders() });
    return data;
  }
};
